import { createSelector } from 'reselect'


export const getContact = state => state.contactUs.contact
export const getEdit = state=> state.contactUs.edit
export const isLoad = state => state.contactUs.load
export const getCalls = state => state.contactUs.calls
export const getContactFirst = createSelector([getContact] , (contacts) => {
    return contacts.find(c => c.first)
  })